import promiseIdle from './lib/promise-idle';
import ready from './lib/ready';
import Accordion from "./lib/Accordion";

ready().then(promiseIdle()).then(function () {
    (new Accordion(document.querySelectorAll('.lylan-faq__title'), {
        name: 'faq-item'
    })).init();
});
